import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { createBrowserHistory, History } from 'history';
import { Root } from './containers';
import configureStore from './configureStore';
import { FrontendLoaderApplicationState } from './redux';

// Make webpack load font and config files
import './font/iconFont.scss';
import './assets/config.json';

// Get the application-wide store instance, prepopulating with state from the server where available.
// Create browser history to use in the Redux store
const history: History = createBrowserHistory();

// Get the application-wide store instance, prepopulating with state from the server where available.
// TODO initial state: load where the server left (see example...)
const initialState: FrontendLoaderApplicationState = (window as any).initialReduxState as FrontendLoaderApplicationState;
const store: Store<FrontendLoaderApplicationState> = configureStore(history, initialState);
ReactDOM.render(
    <Provider store={store}>
        <Root />
    </Provider>,
    document.getElementById('app')
);
